import { Injectable, OnDestroy, inject } from '@angular/core';
import { Subscription, BehaviorSubject } from 'rxjs';
import { HttpService } from './http.service';
import { tap } from 'rxjs/operators';
import { Product } from '../models/product.model';

@Injectable()
export class ShowroomService implements OnDestroy {
    private httpService = inject(HttpService);

    products$ = new BehaviorSubject<Product[] | false>(false);
    private subscriptions = new Subscription();

    /**
     * Dispatch
     */
    dispatch(numberOfProducts = 4): void {
        this.subscriptions.add(
            this.httpService
                .getTopProducts(numberOfProducts)
                .pipe(tap((products) => this.products$.next(products)))
                .subscribe(),
        );
    }

    /**
     * Destroy all pending subscritpions
     */
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
